export default "__VITE_ASSET__BOHtaFid__"